import React, { useCallback } from 'react';
import { Row, Col } from 'antd';
import { IoChevronForward } from 'react-icons/io5';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import AvatarImage from '../../components/cp-account-image';
import useFetchFlowService from '../../hooks/use-fetch-flow-service';
import { redirectToAngular } from '../../utilities/utility';
import HooperLoading from '../../components/cp-spinners/cp-spinner';
import logger from '../../services/logger';

const TopFlowPopover = () => {
  const { flowData, isLoading } = useFetchFlowService();

  const { bizCode } = useParams();

  const { businessFlow, connectors, processorsAndBots } = flowData;

  logger.debug(isLoading);

  const handleShowDataAsPerLength = useCallback(
    (type) => {
      if (type === 'businessFlow') {
        if (businessFlow?.data?.[0]?.length >= 6) {
          return businessFlow?.data?.[0]?.splice(0, 6);
        }
        return businessFlow?.data?.[0];
      }

      if (type === 'connectors') {
        if (connectors?.data?.[0]?.length >= 5) {
          return connectors?.data?.[0]?.splice(0, 5);
        }
        return connectors?.data?.[0];
      }

      if (type === 'processorsAndBots') {
        if (processorsAndBots?.data?.[0]?.length >= 5) {
          return processorsAndBots?.data?.[0]?.splice(0, 5);
        }
        return processorsAndBots?.data?.[0];
      }
    },
    [flowData],
  );

  const onClickFlowCard = (flowType, id) => {
    if (flowType === 'BUSINESS_FLOWS') {
      redirectToAngular(bizCode, `settings/DFC/connector/updateflow/${id}`, '?goto=LIST&type=FLOW');
    } else if (flowType === 'CONNECTORS') {
      redirectToAngular(bizCode, `settings/DFC/connector/updateflow/${id}`, '?goto=LIST');
    } else if (flowType === 'PROCESSORS_BOTS') {
      redirectToAngular(bizCode, 'settings/DFC/processorsList');
    }
  };

  const createFlowCard = (flowType) => {
    if (flowType === 'BUSINESS_FLOWS') {
      redirectToAngular(bizCode, 'settings/DFC/connector/create', '?type=FLOW');
    } else if (flowType === 'CONNECTORS') {
      redirectToAngular(bizCode, 'settings/DFC/connector/create');
    }
  };

  const listFlowCard = (flowType) => {
    if (flowType === 'BUSINESS_FLOWS') {
      redirectToAngular(bizCode, 'settings/DFC/connectorsList', '?type=FLOW');
    } else if (flowType === 'CONNECTORS') {
      redirectToAngular(bizCode, 'settings/DFC/connectorsList');
    } else if (flowType === 'PROCESSORS_BOTS') {
      redirectToAngular(bizCode, 'settings/DFC/processorsList');
    }
  };

  return (
    <>
      {isLoading && <HooperLoading />}
      <Row>
        <Col sm={8}>
          <div className="w-220px pl-7">
            <div className="pl-20 pt-20">
              <h2 className="f-bold f-18 color-text">Business Flows</h2>
            </div>
            <div className="pl-12">
              <ul>
                {handleShowDataAsPerLength('businessFlow')?.map((elem) => {
                  return (
                    <>
                      <li className="p-10 pb-17 header-flow-list">
                        <a
                          onClick={(event) => {
                            event.stopPropagation();
                            onClickFlowCard('BUSINESS_FLOWS', elem?.id);
                          }}
                        >
                          {elem?.iconUrl ? (
                            <>
                              <AvatarImage image={elem?.iconUrl} classValue="header-flow-icon" type="IMAGE" />
                            </>
                          ) : (
                            <>
                              <AvatarImage image={elem?.name?.slice(0, 1).toUpperCase()} type="AVATAR" sizeVal={24} />
                            </>
                          )}
                          <span className="pl-10 f-13 color-text">{elem?.name}</span>
                        </a>
                      </li>
                    </>
                  );
                })}
                <li className="p-10 pb-17">
                  <div className='btn_primary'
                    onClick={(event) => {
                      event.stopPropagation();
                      createFlowCard('BUSINESS_FLOWS');
                    }}
                  >
                    Create Flow
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </Col>
        <Col sm={8}>
          <div className="w-220px pl-7">
            <div className="pl-20 pt-20">
              <h2 className="f-bold f-18 color-text">Connectors</h2>
            </div>
            <div className="pl-12">
              <ul>
                {handleShowDataAsPerLength('connectors')?.map((elem) => {
                  return (
                    <>
                      <li className="p-10 pb-17 header-flow-list">
                        <a
                          onClick={(event) => {
                            event.stopPropagation();
                            onClickFlowCard('CONNECTORS', elem?.id);
                          }}
                        >
                          {elem?.iconUrl ? (
                            <>
                              <AvatarImage image={elem?.iconUrl} classValue="header-flow-icon" type="IMAGE" />
                            </>
                          ) : (
                            <>
                              <AvatarImage image={elem?.name?.slice(0, 1).toUpperCase()} type="AVATAR" sizeVal={24} />
                            </>
                          )}
                          <span className="pl-10 f-13 color-text">{elem?.name}</span>
                        </a>
                      </li>
                    </>
                  );
                })}
                <li className="p-10 pb-17">
                  <span
                    className="f-13 header-flow-see-text display_flex align_items_center"
                    onClick={(event) => {
                      event.stopPropagation();
                      listFlowCard('CONNECTORS');
                    }}
                  >
                    See all <IoChevronForward className="icon_style_18" />
                  </span>
                </li>
                <li className="p-10 pb-17">
                  <div className='btn_primary'
                    onClick={(event) => {
                      event.stopPropagation();
                      createFlowCard('CONNECTORS');
                    }}
                  >
                    Create Connectors
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </Col>
        <Col sm={8}>
          <div className="w-220px pl-7">
            <div className="pl-20 pt-20">
              <h2 className="f-bold f-18 color-text">
                Processors and <br />
                Bots
              </h2>
            </div>
            <div className="pl-12">
              <ul>
                {handleShowDataAsPerLength('processorsAndBots')?.map((elem) => {
                  return (
                    <>
                      <li className="p-10 pb-17 header-flow-list">
                        <a
                          onClick={(event) => {
                            event.stopPropagation();
                            onClickFlowCard('PROCESSORS_BOTS', elem?.id);
                          }}
                        >
                          {elem?.iconUrl ? (
                            <>
                              <AvatarImage image={elem?.iconUrl} classValue="header-flow-icon" type="IMAGE" />
                            </>
                          ) : (
                            <>
                              <AvatarImage image={elem?.name?.slice(0, 1).toUpperCase()} type="AVATAR" sizeVal={24} />
                            </>
                          )}
                          <span className="pl-10 f-13 color-text">{elem?.name}</span>
                        </a>
                      </li>
                    </>
                  );
                })}
                <li className="p-10 pb-17">
                  <span
                    className="f-13 header-flow-see-text display_flex align_items_center"
                    onClick={(event) => {
                      event.stopPropagation();
                      listFlowCard('PROCESSORS_BOTS');
                    }}
                  >
                    See all <IoChevronForward className="icon_style_18" />
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default TopFlowPopover;
